import React from "react";
import { Form } from "react-bootstrap";

export default function ChecklistRenderer({ items = [], editable = false, values = {}, onChange }) {
  if (!items.length) {
    return <div className="text-muted small">Sin checklist obligatorio para esta instancia.</div>;
  }

  return (
    <div className="d-flex flex-column gap-2">
      {items.map((item) => {
        const current = values[item.codigo] || { cumplido: !!item.cumplido, observacion: item.observacion || "" };
        return (
          <div key={item.codigo} className="border rounded p-2 bg-white">
            <Form.Check
              type="checkbox"
              id={`check-${item.codigo}`}
              label={item.codigo.replaceAll("_", " ")}
              checked={!!current.cumplido}
              disabled={!editable}
              onChange={(event) =>
                onChange?.(item.codigo, {
                  ...current,
                  cumplido: event.target.checked,
                })
              }
            />
            <Form.Control
              className="mt-2"
              size="sm"
              placeholder="Observación opcional"
              value={current.observacion || ""}
              disabled={!editable}
              onChange={(event) =>
                onChange?.(item.codigo, {
                  ...current,
                  observacion: event.target.value,
                })
              }
            />
          </div>
        );
      })}
    </div>
  );
}
